import './index.css';
import { Section } from './components/Section';
import { GridDemo } from './components/GridDemo';
import { CellZoom } from './components/CellZoom';
import { EscapeDemo } from './components/EscapeDemo';
import { KeyboardDemo } from './components/KeyboardDemo';
import { MouseDemo } from './components/MouseDemo';
import { SignalsDemo } from './components/SignalsDemo';
import { InputModesDemo } from './components/InputModesDemo';
import { FlowDiagram } from './components/FlowDiagram';
import { AdvancedTUIDemo } from './components/AdvancedTUIDemo';
import { AlternateScreenDemo } from './components/AlternateScreenDemo';
import { IconsDemo } from './components/IconsDemo';
import { StateManagementDemo } from './components/StateManagementDemo';
import { TextSelectionDemo } from './components/TextSelectionDemo';
import { VocabularyDemo } from './components/VocabularyDemo';
import { CapabilityDiscoveryDemo } from './components/CapabilityDiscoveryDemo';
import { ThemeToggle } from './components/shared/ThemeToggle';
import { getSectionCopy } from './content';

function section(id: string) {
  const s = getSectionCopy(id);
  if (!s) throw new Error(`Missing section "${id}" in src/content/sections.ts`);
  return s;
}

export function App() {
  return (
    <div className="min-h-screen px-5 md:px-8">
      <ThemeToggle />
      <Section {...section('header')} />

      <Section {...section('grid')}>
        <GridDemo />
      </Section>

      <Section {...section('cell')}>
        <CellZoom />
      </Section>

      <Section {...section('escape')}>
        <EscapeDemo />
      </Section>

      <Section {...section('input')}>
        <div className="space-y-12">
          <KeyboardDemo />
          <MouseDemo />
        </div>
      </Section>

      <Section {...section('signals')}>
        <SignalsDemo />
      </Section>

      <Section {...section('input-modes')}>
        <InputModesDemo />
      </Section>

      <Section {...section('flow')}>
        <FlowDiagram />
      </Section>

      <Section {...section('advanced-tui')}>
        <AdvancedTUIDemo />
      </Section>

      <Section {...section('alternate-screen')}>
        <AlternateScreenDemo />
      </Section>

      <Section {...section('icons')}>
        <IconsDemo />
      </Section>

      <Section {...section('state')}>
        <StateManagementDemo />
      </Section>

      <Section {...section('selection')}>
        <TextSelectionDemo />
      </Section>

      <Section {...section('capability-discovery')}>
        <CapabilityDiscoveryDemo />
      </Section>

      <Section {...section('vocabulary')}>
        <VocabularyDemo />
      </Section>

      <footer className="max-w-2xl mx-auto pt-16 pb-12 border-t border-terminal-border">
        <p className="text-center text-terminal-dim text-sm">
          © 2026 Hitarth Rohra. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
